import {DEFAULT_COMMENTS_COUNT, DEFAULT_COMMENTS_OFFSET} from './config.js'

const DEFAULT_RESPONSE = {comments: []}

export const getInitialCommentsProps = async ({domain, newsDetailDomainResponse}) => {
  if (!newsDetailDomainResponse) return DEFAULT_RESPONSE.comments

  const {allowComments, id} = newsDetailDomainResponse

  if (!allowComments) return DEFAULT_RESPONSE

  const getCommentsParams = {
    articleId: id,
    items: DEFAULT_COMMENTS_COUNT,
    pageNumber: DEFAULT_COMMENTS_OFFSET
  }

  const [domainCommentsError, domainCommentsResponse] = await domain
    .get('get_news_comments_reviews_use_case')
    .execute(getCommentsParams)

  return domainCommentsError ? DEFAULT_RESPONSE.comments : domainCommentsResponse.comments
}
